import React from 'react'
import { Link, useLocation } from 'react-router-dom';

export const MenuItem = ({url, title, activeLinks = []}) => {
  const {pathname} = useLocation()

  return (
    <div className="menu-item here show menu-lg-down-accordion me-lg-1">
        <Link to={url} className="menu-title">
            <button className={`menu-link py-3 rounded-pill ${activeLinks.some(link => pathname.includes(link)) ? 'active' : ''}`}>{title}</button>
        </Link>
    </div>
  )
}
